import {
  TOGGLE_DRAWER,
  SET_DRAWER_MODE,
  SET_MOBILE_STATE,
  SET_FORCE_HIDE_NAV,
  DrawerDisplayMode,
  ToggleDrawerAction,
  SetDrawerModeAction,
  SetMobileStateAction,
  SetForceHideNavAction,
} from './types'

export const toggleDrawer = (): ToggleDrawerAction => ({
  type: TOGGLE_DRAWER,
})

export const setDrawerMode = (
  mode: DrawerDisplayMode
): SetDrawerModeAction => ({
  type: SET_DRAWER_MODE,
  payload: mode,
})

export const setMobileState = (isMobile: boolean): SetMobileStateAction => ({
  type: SET_MOBILE_STATE,
  payload: isMobile,
})

export const setForceHideNav = (forceHide: boolean): SetForceHideNavAction => ({
  type: SET_FORCE_HIDE_NAV,
  payload: forceHide,
})
